package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.create_product_ingredients


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Data(
    @SerialName("cashAssist")
    val cashAssist: CashAssist?
)